export default [
    {
        path: 'notificacao',
        component: () => import(/* webpackChunkName: 'administracao-notificacao' */ '@/views/administracao/notificacao/Index'),
        redirect: 'notificacao/index',
        children: [
            {
                name: 'administracao-notificacao-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'administracao-notificacao' */ '@/views/administracao/notificacao/List.vue'),
            },
            {
                name: 'administracao-notificacao-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'administracao-notificacao' */ '@/views/administracao/notificacao/Form.vue'),
            },
            {
                name: 'administracao-notificacao-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
                component: () => import(/* webpackChunkName: 'administracao-notificacao' */ '@/views/administracao/notificacao/Form.vue'),
            },
        ],
    },
]